//@ts-nocheck
"use-client"
import { GoArrowLeft, GoArrowRight, GoDotFill } from "react-icons/go";
import BannerHeadline from "../atoms/banner-headline";
import styles from './navigation-split.module.css'
import { slugBuilder } from "../../utils/slug-builder";
import Slider from "../atoms/slider";
import { imageInterpreter } from "../../utils/images-interpreter";
import Title from "../atoms/title";

import { useState, useEffect } from "react";
import Link from "next/link";

export default function NavigationSplit({ left, right }) {

    // SSR-safe: this runs during render, so `window` isn't available on the server.
    const [windowSize, setWindowSize] = useState(typeof window !== "undefined" ? window.innerWidth : 0);
    const [size, setSize] = useState("32")


    // Track the current window width
    useEffect(() => {
        const handleResize = () => {
            const maxWidth = window.innerWidth;
            setWindowSize(maxWidth);

            // Adjust size based on maxWidth
            if (maxWidth <= 768) {
                setSize("20");
            } else if (maxWidth <= 1024) {
                setSize("18");
            } else {
                setSize("32");
            }
        };

        window.addEventListener("resize", handleResize);

        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const leftAttrs = left?.attributes?.page?.attributes || left;
    const rightAttrs = right?.attributes?.page?.attributes || right;
    //console.log("Interpreted left and right attributes:", { leftAttrs, rightAttrs });
    const leftImgs = leftAttrs?.vxiContent?.attributes?.images || leftAttrs?.section?.find(section => section?.attributes?.__component === 'layout.hero' || section?.attributes?.__component === 'specials.hub-spot-hero' || section?.attributes?.__component === 'specials.hero-page-filter')?.attributes?.images || leftAttrs?.images;
    const rightImgs = rightAttrs?.vxiContent?.attributes?.images || rightAttrs?.section?.find(section => section?.attributes?.__component === 'layout.hero' || section?.attributes?.__component === 'specials.hub-spot-hero' || section?.attributes?.__component === 'specials.hero-page-filter')?.attributes?.images || rightAttrs?.images;
    // const leftLink = left?.page?.data?.attributes?.menuTitle || left?.page?.data?.attributes?.subMenuTitle ? `/${slugBuilder(left?.page?.data?.attributes?.menuTitle, left?.page?.data?.attributes?.subMenuTitle, left?.page?.data?.attributes?.title)}` : (left?.page?.data?.attributes?.hubSpotLink ?? `/${slugBuilder(left?.page?.data?.attributes?.sections, null, left?.page?.data?.attributes?.title)}`)
    // const rightLink = right?.page?.data?.attributes?.menuTitle || right?.page?.data?.attributes?.subMenuTitle ? `/${slugBuilder(right?.page?.data?.attributes?.menuTitle, right?.page?.data?.attributes?.subMenuTitle, right?.page?.data?.attributes?.title)}` : (right?.page?.data?.attributes?.hubSpotLink ?? `/${slugBuilder(right?.page?.data?.attributes?.sections, null, right?.page?.data?.attributes?.title)}`)
    const leftLink =
        leftAttrs?.title === "Careers"
            ? "https://jobs.vxi.com/"
            : (leftAttrs?.menuTitle || leftAttrs?.subMenuTitle)
                ? `/${slugBuilder(leftAttrs?.menuTitle, leftAttrs?.subMenuTitle, leftAttrs?.title)}`
                : (leftAttrs?.hubSpotLink ?? `/${slugBuilder(leftAttrs?.section?.attributes?.title, null, leftAttrs?.title)}`);

    const rightLink =
        rightAttrs?.title === "Careers"
            ? "https://jobs.vxi.com/"
            : (rightAttrs?.menuTitle || rightAttrs?.subMenuTitle)
                ? `/${slugBuilder(rightAttrs?.menuTitle, rightAttrs?.subMenuTitle, rightAttrs?.title)}`
                : (rightAttrs?.hubSpotLink ?? `/${slugBuilder(rightAttrs?.section?.attributes?.title, null, rightAttrs?.title)}`);
    return (
        <>

            {/* Size changes from pt to px default 32 */}

            {leftAttrs && rightAttrs && (<div className={styles['split-wrapper']}>
                <div className={styles.left}>
                    {(left?.replacementTitle ?? leftAttrs?.title) && (
                        <>
                            <Link href={leftLink} legacyBehavior>
                                <a href={leftLink} target={leftAttrs?.title === "Careers" || left?.newTab ? "_blank" : undefined}>
                                    <GoDotFill size={14} color="white" />
                                    <Title title={left?.replacementTitle ?? leftAttrs?.title} textAlign="right" size={`${size}px`} dynamic={false} />
                                    <div className={styles.image}>
                                        <Slider imageList={imageInterpreter(leftImgs)} mode="full" />
                                    </div>
                                </a>
                            </Link>
                            <Link href={leftLink} legacyBehavior>
                                <a href={leftLink} target={leftAttrs?.title === "Careers" || left?.newTab ? "_blank" : undefined}>
                                    <GoArrowLeft size={35} />
                                    <Title title={left?.replacementTitle ?? leftAttrs?.title} textAlign="right" size={`${size}px`} dynamic={false} />
                                </a>
                            </Link>
                        </>
                    )}
                </div>
                {(right?.replacementTitle ?? rightAttrs?.title) && (<div className={styles.right}>
                    <Link href={rightLink} legacyBehavior>
                        <a href={rightLink} target={rightAttrs?.title === "Careers" || right?.newTab ? "_blank" : undefined}>
                            {/* {right?.page?.data?.attributes?.types} */}
                            <Title title={right?.replacementTitle ?? rightAttrs?.title} size={`${size}px`} dynamic={false} />
                            <GoDotFill size={14} color="white" />
                            <div className={styles.image}>
                                {<Slider imageList={imageInterpreter(rightImgs)} mode="full" />}
                            </div>
                        </a>
                    </Link>
                    <Link href={rightLink} legacyBehavior>
                        <a href={rightLink} target={rightAttrs?.title === "Careers" || right?.newTab ? "_blank" : undefined}>
                            <Title title={right?.replacementTitle ?? rightAttrs?.title} size={`${size}px`} dynamic={false} />
                            <GoArrowRight size={35} />
                        </a>
                    </Link>
                </div>)}
            </div>)}
        </>

    )
} 